import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useApiCall } from "../../useApiCall";
import Spinner from "../../Spinner";
import "./quiz.css";

const ANSWER_KEYS = ["A", "B", "C"];

const Quiz = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const getQuiz = useApiCall("/courses", "GET");
  const checkQuiz = useApiCall("/courses", "POST");
  const completeCourse = useApiCall("/courses", "POST");

  const [questions, setQuestions] = useState(null);
  const [selected, setSelected] = useState({});
  const [results, setResults] = useState(null);
  const [allCorrect, setAllCorrect] = useState(false);
  const [checking, setChecking] = useState(false);
  const [completing, setCompleting] = useState(false);

  useEffect(() => {
    const abort = new AbortController();

    setQuestions(null);
    setSelected({});
    setResults(null);
    setAllCorrect(false);

    getQuiz(undefined, `/${id}/quiz`, { signal: abort.signal }).then(
      (resp) => {
        if (Array.isArray(resp)) {
          setQuestions(resp);
        }
      },
    );

    return () => abort.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const selectAnswer = (questionId, answer) => {
    setSelected((prev) => ({ ...prev, [questionId]: answer }));
    setResults(null);
    setAllCorrect(false);
  };

  const allAnswered =
    questions && questions.every((q) => selected[q.id] !== undefined);

  const handleCheck = () => {
    setChecking(true);
    checkQuiz(JSON.stringify({ answers: selected }), `/${id}/quiz/check`)
      .then((resp) => {
        if (resp) {
          setResults(resp.results || {});
          setAllCorrect(!!resp.allCorrect);
        }
      })
      .finally(() => setChecking(false));
  };

  const handleComplete = () => {
    setCompleting(true);
    completeCourse(undefined, `/${id}/complete`)
      .then(() => navigate("/courses"))
      .finally(() => setCompleting(false));
  };

  const hasQuestions = questions && questions.length > 0;

  return (
    <Container fluid>
      <div className="page-header d-flex justify-content-between align-items-center">
        <h2>Κουίζ μαθήματος</h2>
        <Button
          color="secondary"
          size="sm"
          onClick={() => navigate(`/courses/${id}`)}
        >
          <FontAwesomeIcon icon="arrow-left" /> Πίσω στο μάθημα
        </Button>
      </div>

      {questions === null && <Spinner />}

      <Row className="justify-content-center">
        <Col xs="12" md="10" lg="7">
          {questions !== null && !hasQuestions && (
            <span className="text-muted">
              Δεν υπάρχει διαθέσιμο κουίζ για αυτό το μάθημα&hellip;
            </span>
          )}

          {hasQuestions &&
            questions.map((q, index) => {
              const questionResult = results ? results[q.id] : undefined;
              return (
                <div
                  key={q.id}
                  className={index === 0 ? "mt-4 mb-4" : "mb-4"}
                >
                  <div className="fw-bold mb-2">
                    {index + 1}. {q.question}{" "}
                    {questionResult === true && (
                      <FontAwesomeIcon
                        icon="check"
                        className="text-success ms-1"
                      />
                    )}
                    {questionResult === false && (
                      <FontAwesomeIcon
                        icon="times"
                        className="text-danger ms-1"
                      />
                    )}
                  </div>
                  {ANSWER_KEYS.map((key) => (
                    <FormGroup
                      check
                      key={key}
                      className={
                        "quiz-option" +
                        (selected[q.id] === key ? " quiz-option-selected" : "")
                      }
                      onClick={() => selectAnswer(q.id, key)}
                    >
                      <Label check>
                        <Input
                          type="radio"
                          name={`question-${q.id}`}
                          checked={selected[q.id] === key}
                          onChange={() => selectAnswer(q.id, key)}
                        />{" "}
                        {q[`answer${key}`]}
                      </Label>
                    </FormGroup>
                  ))}
                  {questionResult === false && (
                    <div className="text-danger small mt-1">
                      Λάθος απάντηση, δοκιμάστε ξανά.
                    </div>
                  )}
                </div>
              );
            })}

          {hasQuestions && (
            <div className="text-center mt-4 mb-5">
              {!allCorrect && (
                <Button
                  color="primary"
                  disabled={!allAnswered || checking}
                  onClick={handleCheck}
                >
                  Έλεγχος απαντήσεων
                </Button>
              )}

              {allCorrect && (
                <Button
                  color="success"
                  disabled={completing}
                  onClick={handleComplete}
                >
                  <FontAwesomeIcon icon="check" /> Ολοκλήρωση μαθήματος
                </Button>
              )}
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Quiz;
